import React, { useEffect, useRef, useState } from "react";
import SingleClinic from "../../Components/RegistrationForm/SingleClinic";
import ReactPlayer from "react-player";
import SelectSearch from "react-select-search";
import "./select.css";

function Index(props) {
    const [country, setCountry] = useState(null);
    const [countries, setCountries] = useState(props.countries);
    const [otherCountry, setOtherCountry] = useState(null);
    const deviceImgRef = useRef(null);
    const [disableRegister, setDisableRegister] = useState(false);
    useEffect(() => {
        console.log(props.agent);

        if (props.agent != null) {
            setCountry(props.agentCountry.toLowerCase());
        }
    }, []);

    useEffect(() => {
        if (country == null && otherCountry == null) {
            setDisableRegister(true);
        } else if (country != null && props.redirectionLinks[country] == "") {
            setDisableRegister(true);
        } else {
            setDisableRegister(false);
        }
    }, [country, otherCountry]);

    // set width of video based on 86% width and height of device image
    const videoContainerRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            if (deviceImgRef.current) {
                const deviceImgWidth = deviceImgRef.current.offsetWidth;
                const deviceImgHeight = deviceImgRef.current.offsetHeight;
                const videoWidth = deviceImgWidth * 0.96;
                const videoHeight = deviceImgHeight * 0.8;
                videoContainerRef.current.style.width = `${videoWidth}px`;
                videoContainerRef.current.style.height = `${videoHeight}px`;
                // console.log(deviceImgRef.current.offsetParent);
                videoContainerRef.current.style.top = `${
                    deviceImgRef.current.offsetTop + deviceImgHeight * 0.02
                }px`;
                videoContainerRef.current.style.left = `${
                    deviceImgRef.current.offsetLeft + deviceImgWidth * 0.02
                }px`;
            }
        };

        const observer = new MutationObserver(() => {
            if (deviceImgRef.current && deviceImgRef.current.offsetWidth > 0) {
                console.log(deviceImgRef.current.offsetWidth);
                handleResize();
                observer.disconnect();
            }
        });

        observer.observe(document, {
            childList: true,
            subtree: true,
        });

        setTimeout(() => {
            handleResize();
        }, 1000);

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [deviceImgRef]);

    const getIconByCountry = (country) => {
        country = country.toLowerCase();
        switch (country) {
            case "sg":
                return "/assets/img/ico-singapore.png";
            case "id":
                return "/assets/img/ico-indonesia.png";
            case "my":
                return "/assets/img/ico-malaysia.png";
            case "ph":
                return "/assets/img/ico-philippines.png";
            case "vn":
                return "/assets/img/ico-vietnam.png";
            case "au":
                return "/assets/img/ico-australia.png";
            case "th":
                return "/assets/img/ico-thailand.png";
            default:
                return "";
        }
    };

    const getCountryNameByCountryCode = (country) => {
        country = country.toLowerCase();
        switch (country) {
            case "sg":
                return "Singapore";
            case "id":
                return "Indonesia";
            case "my":
                return "Malaysia";
            case "ph":
                return "Philippines";
            case "vn":
                return "Vietnam";
            case "au":
                return "Australia";
            case "th":
                return "Thailand";
            default:
                return "";
        }
    };

    return (
        <div className="landing-bg">
            <div
                className="w-100 flex-1 d-flex flex-column justify-content-center"
                style={{ flex: 1 }}
            >
                <div className="row">
                    <div className="d-flex align-items-center relative landing-left-column px-5">
                        <img
                            style={{
                                width: "90%",
                                margin: "auto",
                            }}
                            src="/assets/img/Device.png"
                            ref={deviceImgRef}
                        />
                        <div
                            ref={videoContainerRef}
                            style={{
                                position: "absolute",
                                display: "flex",
                                alignItems: "center",
                                // top: "43%",
                                // transform: "translateY(-50%)",
                            }}
                        >
                            <ReactPlayer
                                style={{
                                    width: "100%",
                                    height: "100%",
                                }}
                                height="100%"
                                width="100%"
                                light={
                                    "/assets/img/landing_video_thumbnail.png"
                                }
                                playing={true}
                                controls={true}
                                url={props.videoLink}
                                config={{
                                    file: {
                                        attributes: {
                                            controlsList: "nodownload",
                                        },
                                    },
                                }}
                            />
                        </div>
                    </div>
                    <div className="flex-column d-flex py-5 justify-content-center align-items-center landing-right-column">
                        {/* <div className=" justify-content-center"> */}
                        <div className="w-full text-center text-white pt-2 mb-2 px-5">
                            <img
                                style={{ height: "4.5rem", margin: "auto" }}
                                src="/assets/img/logo.png"
                            />
                            <h3 className="text-white mt-5">
                                AI-Driven Dentistry Innovation
                            </h3>
                            <p>
                                Join our vibrant AI-powered dentistry community
                                by registering for our AI product.
                            </p>
                        </div>

                        <div
                            // ref={videoContainerRef}
                            className="d-flex landing-video-container"
                            style={{
                                width: "100vw",
                                height: "56vw",
                                alignItems: "center",
                            }}
                        >
                            <ReactPlayer
                                style={{
                                    width: "100%",
                                    height: "100%",
                                }}
                                height="100%"
                                width="100%"
                                light={
                                    "/assets/img/landing_video_thumbnail.png"
                                }
                                playing={true}
                                controls={true}
                                url={props.videoLink}
                                config={{
                                    file: {
                                        attributes: {
                                            controlsList: "nodownload",
                                        },
                                    },
                                }}
                            />
                        </div>

                        <div
                            className="mt-4 w-full"
                            style={{
                                background:
                                    "#FFFFFF 0% 0% no-repeat padding-box",
                                boxShadow: "0px 3px 6px #00000029",
                                borderRadius: "30px",
                                padding: "2rem 1rem",
                                margin: "auto",
                                // maxWidth: "95vw",
                                width: "85%",
                            }}
                        >
                            {props.agent == null && (
                                <div
                                    style={{
                                        position: "relative",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flexDirection: "column",
                                    }}
                                >
                                    <img
                                        src="/assets/img/ico-map.svg"
                                        style={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                        }}
                                    />
                                    <img
                                        src="/assets/img/ico-map.svg"
                                        style={{ visibility: "hidden" }}
                                    />
                                    <h5
                                        style={{
                                            fontWeight: "bold",
                                            textWrap: "nowrap",
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                        }}
                                    >
                                        Choose your location
                                    </h5>
                                </div>
                            )}

                            <div className="container mt-3">
                                {props.agent == null && (
                                    <div className="row no-gutters">
                                        {props.redirectionLinks["sg"] != "" && (
                                            <div className="col-12 col-sm-6 p-1 pb-3">
                                                <div
                                                    onClick={() => {
                                                        setOtherCountry(null);
                                                        setCountry("sg");
                                                    }}
                                                    className={`country-button ${
                                                        country == "sg" &&
                                                        "active"
                                                    }`}
                                                >
                                                    <img
                                                        style={{
                                                            width: 32,
                                                        }}
                                                        src="/assets/img/ico-singapore.png"
                                                        className="mr-2"
                                                    />
                                                    <p className="mb-0">
                                                        Singapore
                                                    </p>
                                                </div>
                                            </div>
                                        )}

                                        {props.redirectionLinks["my"] != "" && (
                                            <div className="col-12 col-sm-6 p-1 pb-3">
                                                <div
                                                    onClick={() => {
                                                        setOtherCountry(null);
                                                        setCountry("my");
                                                    }}
                                                    className={`country-button ${
                                                        country == "my" &&
                                                        "active"
                                                    }`}
                                                >
                                                    <img
                                                        style={{
                                                            width: 32,
                                                        }}
                                                        src="/assets/img/ico-malaysia.png"
                                                        className="mr-2"
                                                    />
                                                    <p className="mb-0">
                                                        Malaysia
                                                    </p>
                                                </div>
                                            </div>
                                        )}

                                        {props.redirectionLinks["id"] != "" && (
                                            <div className="col-12 col-sm-6 p-1 pb-3">
                                                <div
                                                    onClick={() => {
                                                        setOtherCountry(null);
                                                        setCountry("id");
                                                    }}
                                                    className={`country-button ${
                                                        country == "id" &&
                                                        "active"
                                                    }`}
                                                >
                                                    <img
                                                        style={{
                                                            width: 32,
                                                        }}
                                                        src="/assets/img/ico-indonesia.png"
                                                        className="mr-2"
                                                    />
                                                    <p className="mb-0">
                                                        Indonesia
                                                    </p>
                                                </div>
                                            </div>
                                        )}

                                        {props.redirectionLinks["ph"] != "" && (
                                            <div className="col-12 col-sm-6 p-1 pb-3">
                                                <div
                                                    onClick={() => {
                                                        setOtherCountry(null);
                                                        setCountry("ph");
                                                    }}
                                                    className={`country-button ${
                                                        country == "ph" &&
                                                        "active"
                                                    }`}
                                                >
                                                    <img
                                                        style={{
                                                            width: 32,
                                                        }}
                                                        src="/assets/img/ico-philippines.png"
                                                        className="mr-2"
                                                    />
                                                    <p className="mb-0">
                                                        Philippines
                                                    </p>
                                                </div>
                                            </div>
                                        )}

                                        {props.redirectionLinks["vn"] != "" && (
                                            <div className="col-12 col-sm-6 p-1 pb-3">
                                                <div
                                                    onClick={() => {
                                                        setOtherCountry(null);
                                                        setCountry("vn");
                                                    }}
                                                    className={`country-button ${
                                                        country == "vn" &&
                                                        "active"
                                                    }`}
                                                >
                                                    <img
                                                        style={{
                                                            width: 32,
                                                        }}
                                                        src="/assets/img/ico-vietnam.png"
                                                        className="mr-2"
                                                    />
                                                    <p className="mb-0">
                                                        Vietnam
                                                    </p>
                                                </div>
                                            </div>
                                        )}

                                        {props.redirectionLinks["au"] != "" && (
                                            <div className="col-12 col-sm-6 p-1 pb-3">
                                                <div
                                                    onClick={() => {
                                                        setOtherCountry(null);
                                                        setCountry("au");
                                                    }}
                                                    className={`country-button ${
                                                        country == "au" &&
                                                        "active"
                                                    }`}
                                                >
                                                    <img
                                                        style={{
                                                            width: 32,
                                                        }}
                                                        src="/assets/img/ico-australia.png"
                                                        className="mr-2"
                                                    />
                                                    <p className="mb-0">
                                                        Australia
                                                    </p>
                                                </div>
                                            </div>
                                        )}

                                        {props.redirectionLinks["th"] != "" && (
                                            <div className="col-12 col-sm-6 p-1 pb-3">
                                                <div
                                                    onClick={() => {
                                                        setOtherCountry(null);
                                                        setCountry("th");
                                                    }}
                                                    className={`country-button ${
                                                        country == "th" &&
                                                        "active"
                                                    }`}
                                                >
                                                    <img
                                                        style={{
                                                            width: 32,
                                                        }}
                                                        src="/assets/img/ico-thailand.png"
                                                        className="mr-2"
                                                    />
                                                    <p className="mb-0">
                                                        Thailand
                                                    </p>
                                                </div>
                                            </div>
                                        )}

                                        {props.redirectionLinks["other"] !=
                                            "" && (
                                            <div className="col-12 col-sm-6 p-1">
                                                <SelectSearch
                                                    options={countries}
                                                    value={otherCountry}
                                                    search={true}
                                                    onChange={(value) => {
                                                        setOtherCountry(value);
                                                        setCountry(null);
                                                    }}
                                                    name="other-country"
                                                    placeholder="Other Location"
                                                />
                                            </div>
                                        )}
                                    </div>
                                )}

                                {props.agent != null && (
                                    <div className="d-flex flex-column justify-content-center align-items-center">
                                        <div>
                                            <img
                                                style={{
                                                    // width: 70,
                                                    height: 70,
                                                    borderRadius: props.agent.logo != null ? "0" : "100%",
                                                }}
                                                src={
                                                    props.agent.logo != null
                                                        ? `/aiscan-register/avatar/${props.agent.code}?agentCountry=${props.agentCountry}`
                                                        : `/assets/img/ico-avatar.png`
                                                }
                                            />
                                        </div>
                                        <h4 className="mt-2 text-center">
                                            {props.agent.name}
                                        </h4>
                                        <p className="font-bold mt-2">
                                            Selected Location:
                                        </p>
                                        <div
                                            style={{
                                                border: "1px solid #36A493",
                                                borderRadius: "6px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                flexDirection: "column",
                                            }}
                                            className="py-2 px-3"
                                        >
                                            <img
                                                style={{ width: 44 }}
                                                src={getIconByCountry(
                                                    props.agentCountry
                                                )}
                                                className=""
                                            />
                                            <p className="mb-0">
                                                {getCountryNameByCountryCode(
                                                    props.agentCountry
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="mt-4 d-flex justify-content-center w-full">
                                <button
                                    onClick={() => {
                                        let link = "";
                                        if (country) {
                                            link =
                                                props.redirectionLinks[country];
                                            if (props.agent) {
                                                link = `${link}/${props.agent.code}`;
                                            }
                                        } else if (otherCountry) {
                                            link = props.redirectionLinks["others"] || "https://aiscan.em2.ai/other/company/register";
                                            if (props.agent) {
                                                link = `${link}/${props.agent.code}`;
                                            }
                                            link = link + "?country=" + otherCountry;
                                        }
                                        window.location.href = link;
                                    }}
                                    disabled={disableRegister}
                                    className="btn primary-button font-bold py-2 px-5 text-white"
                                >
                                    Register Now
                                </button>
                            </div>

                            {props.agent == null && (
                                <div className="mt-4 text-center">
                                    <hr className="mb-4" />
                                    <p>
                                        Got a question or interested in
                                        collaboration? Drop us a message, and
                                        we'll respond promptly.
                                    </p>

                                    <a target="_blank" href="/contact">
                                        <button
                                            className="btn py-2 px-5 mx-auto"
                                            style={{
                                                background:
                                                    "#FFFFFF 0% 0% no-repeat padding-box",
                                                border: "1px solid #36A493",
                                                color: "#36A493",
                                                borderRadius: 25,
                                            }}
                                        >
                                            Contact Us
                                        </button>
                                    </a>
                                </div>
                            )}
                        </div>
                        {/* </div> */}
                    </div>
                </div>
            </div>
            <div
                style={{
                    background:
                        "rgba(255, 255, 255, 0.2) 0% 0% no-repeat padding-box",
                }}
                className="w-100 text-center py-1"
            >
                <span className="text-white">
                    Copyright © 2019-{new Date().getFullYear()}{" "}
                    <a
                        style={{
                            color: "#0000EE",
                            cursor: "pointer",
                        }}
                        href="https://em2.ai"
                        // className="color-primary"
                        target="_blank"
                    >
                        EM2Ai Pte Ltd
                    </a>
                    . All Rights Reserved.{" "}
                    <a
                        href="#"
                        data-toggle="modal"
                        data-target="#exampleModalLong"
                        // className="color-primary"
                        style={{
                            color: "#0000EE",
                            cursor: "pointer",
                        }}
                    >
                        Privacy Policy
                    </a>
                    .
                </span>
            </div>
        </div>
    );
}

export default Index;
